export const SurveySuperProperties = {
    surveyName: 'survey_name',
    defaultLanguage: 'default_language',
    surveyConfigurationId: 'survey_configuration',
    linkId: 'link',
    language: 'language'
};
